export enum CenterContactPosition {
    Other = 0,
    KidneyExchangeCoordinator = 1,
    KidneyMedicalDirector = 5,
    KidneySurgicalDirector = 6,
    KidneyProgramAdministrator = 7,
    LabDirector = 9,
    MediaRelations = 11,
    NkrBillingContact = 13,
    KidneyFinancialContact = 14,
    PrimaryFinAgrmtContact = 15,
    SecFinAgrmtContact = 16,
    KidneyDonorSurgeon = 19,
    KidneyRecipientSurgeon = 20,
    KidneyDonorReferralManager = 21,
    KidneyPatientReferralManager = 210,
    KpdPhysicianLead = 22,
    KidneyGpsManager = 23,
    Nephrologist = 24,
    KidneySocialWorker = 25,
    OpoContact = 26,
    KidneyMicrositeManager = 31,
    KidneyDonorShieldManager = 32,
    KidneyIlda = 33,

    MicrositeCoach = 39,
    ExpertSystemReferralManager = 40,
    KFLPostTransplantCoordinator = 41,

    Researcher = 42,
    HospitalCeo = 43,
    HospitalCfo = 44,

    LiverCoordinator = 38,
    LiverMedicalDirector = 50,
    LiverSurgicalDirector = 51,
    LiverProgramAdministrator = 52,
    NlrBillingContact = 53,
    LiverFinancialContact = 54,
    LiverDonorSurgeon = 55,
    LiverRecipientSurgeon = 56,
    LiverDonorReferralManager = 57,
    LiverPatientReferralManager = 58,
    LpdPhysicianLead = 59,
    LiverGpsManager = 60,
    Hepatologist = 61,
    LiverSocialWorker = 62,
    LiverMicrositeManager = 63,
    LiverDonorShieldManager = 64,
    LiverIlda = 65,
    LiverRecipientPostTransplantCoordinator = 67,
    LiverDonorPostDonationCoordinator = 68,
}

export enum NkrContactPosition {
    MemberServices = 1,
    NkrLiaison = 2,
    Developer = 4,
    DonorServices = 5,
    MicrositeCoach = 6,
    RccapManager = 7,
    SwapManager = 8,
    FinancialController = 9,
    Cfo = 10,
    Operations = 11,
    DirectorOperations = 12,
    MicrositeManager = 13,
    LegalCounsel = 14,
    DutyOfficer = 15,
    EmailSender = 16,
    ChiefInformationOfficer = 17,
    ChiefOperatingOfficer = 18,
    ChiefStrategyOfficer = 19,
    Finance = 20,
    FounderAndChiefExecutiveOfficer = 21,
    LivingKidneyDonor = 22,
    MicrositeProductManager = 23,
    VicePresidentOfAccounting = 24,
    VicePresidentOfMarketing = 25,
    VicePresidentOfNetworkDevelopment = 26,
    VicePresidentOfResearchAndTechnology = 27,
    ClmManager = 28,
    ClmCoach = 29
}

export enum OpoContactPosition {
    Other = 0,
    Ceo = 1,
    MedicalDirector = 2,
    LogisticsCoordinatorPrimary = 3,
    LogisticsCoordinatorSecondary = 4,
    OperationsManager = 5,
    FinancialContact = 6
}